module.exports = __webpack_public_path__ + "static/media/lu.efeee66c.svg";